import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import './Team.css';

const TODAY = new Date().toISOString().split('T')[0];
const STORAGE_KEY = 'ryzenos_team';

const INIT_MEMBERS = [
  { id:1, name:'Lakshmi R',   role:'Sales Lead',       dept:'Sales',   phone:'+91 98001 11111', email:'lakshmi@ryzenforge.in',  avatar:'LR', performance:90, status:'present', leaveBalance:12, joinDate:'2024-01-15', tasks:{done:18,total:20}, username:'lakshmi', password:'Lakshmi@123',   userRole:'Admin' },
  { id:2, name:'Arjun Menon', role:'Sales Executive',  dept:'Sales',   phone:'+91 98001 22222', email:'arjun@ryzenforge.in',    avatar:'AM', performance:85, status:'present', leaveBalance:8,  joinDate:'2024-03-10', tasks:{done:15,total:18}, username:'arjun',   password:'Arjun@123',     userRole:'User' },
  { id:3, name:'Meera Nair',  role:'Ops Manager',      dept:'Ops',     phone:'+91 98001 33333', email:'meera@ryzenforge.in',    avatar:'MN', performance:72, status:'leave',   leaveBalance:5,  joinDate:'2024-02-01', tasks:{done:10,total:14}, username:'meera',   password:'Meera@123',     userRole:'User' },
  { id:4, name:'Kiran Das',   role:'Finance Analyst',  dept:'Finance', phone:'+91 98001 44444', email:'kiran@ryzenforge.in',    avatar:'KD', performance:60, status:'leave',   leaveBalance:10, joinDate:'2024-06-01', tasks:{done:8, total:13}, username:'kiran',   password:'Kiran@123',     userRole:'User' },
  { id:5, name:'Sneha Pillai',role:'Marketing Exec',   dept:'Mktg',    phone:'+91 98001 55555', email:'sneha@ryzenforge.in',    avatar:'SP', performance:78, status:'present', leaveBalance:14, joinDate:'2024-04-20', tasks:{done:12,total:16}, username:'sneha',   password:'Sneha@123',     userRole:'User' },
  { id:6, name:'Ravi Kumar',  role:'Tech Lead',        dept:'Tech',    phone:'+91 98001 66666', email:'ravi@ryzenforge.in',     avatar:'RK', performance:92, status:'present', leaveBalance:9,  joinDate:'2023-11-05', tasks:{done:22,total:24}, username:'ravi',    password:'Ravi@123',      userRole:'Admin' },
  { id:7, name:'Divya S',     role:'HR Executive',     dept:'HR',      phone:'+91 98001 77777', email:'divya@ryzenforge.in',    avatar:'DS', performance:88, status:'present', leaveBalance:11, joinDate:'2024-01-28', tasks:{done:16,total:18}, username:'divya',   password:'Divya@123',     userRole:'User' },
  { id:8, name:'Arun George', role:'Sales Executive',  dept:'Sales',   phone:'+91 98001 88888', email:'arun@ryzenforge.in',     avatar:'AG', performance:65, status:'absent',  leaveBalance:7,  joinDate:'2024-07-12', tasks:{done:9, total:15}, username:'arun',    password:'Arun@123',      userRole:'User' },
  { id:9, name:'Pooja Varma', role:'Content Writer',   dept:'Mktg',    phone:'+91 98001 99999', email:'pooja@ryzenforge.in',    avatar:'PV', performance:80, status:'present', leaveBalance:13, joinDate:'2024-05-03', tasks:{done:14,total:17}, username:'pooja',   password:'Pooja@123',     userRole:'User' },
  {id:10, name:'Sanjay T',    role:'Dev Engineer',     dept:'Tech',    phone:'+91 98001 10101', email:'sanjay@ryzenforge.in',   avatar:'ST', performance:75, status:'present', leaveBalance:6,  joinDate:'2024-08-19', tasks:{done:11,total:15}, username:'sanjay',  password:'Sanjay@123',    userRole:'User' },
  {id:11, name:'Nisha Raj',   role:'Accounts Exec',    dept:'Finance', phone:'+91 98001 11211', email:'nisha@ryzenforge.in',    avatar:'NR', performance:83, status:'present', leaveBalance:10, joinDate:'2024-03-30', tasks:{done:15,total:18}, username:'nisha',   password:'Nisha@123',     userRole:'User' },
  {id:12, name:'Vijay P',     role:'Sales Executive',  dept:'Sales',   phone:'+91 98001 12312', email:'vijay@ryzenforge.in',    avatar:'VP', performance:55, status:'absent',  leaveBalance:4,  joinDate:'2024-09-01', tasks:{done:7, total:13}, username:'vijay',   password:'Vijay@123',     userRole:'User' },
];

const DEPTS = ['All','Sales','Ops','Finance','Mktg','Tech','HR'];
const USER_ROLES = ['Super Admin','Admin','User'];
const perfColor = p => p>=80?'#22C55E':p>=65?'#F5A623':'#EF4444';

const PhoneIcon = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.37 2 2 0 0 1 3.58 1h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.46a16 16 0 0 0 6.29 6.29l1.46-1.46a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>;
const MailIcon  = () => <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const CloseIcon = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const PlusIcon  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>;
const EditIcon  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const EyeIcon   = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>;
const EyeOffIcon= () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>;

function StatusPill({ status }) {
  const map = { present:['tm-s-green','Present'], leave:['tm-s-amber','On Leave'], absent:['tm-s-red','Absent'] };
  const [cls, label] = map[status]||['tm-s-gray','—'];
  return <span className={`tm-status ${cls}`}>{label}</span>;
}

function MemberPanel({ member, theme, onClose, onUpdate, onDelete }) {
  const [tab, setTab] = useState('overview');
  const [form, setForm] = useState({...member});
  const [showPw, setShowPw] = useState(false);
  const [newTask, setNewTask] = useState('');
  const [taskList, setTaskList] = useState(member.taskList || []);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const pct = Math.round((form.tasks.done/form.tasks.total)*100)||0;

  const save = () => { onUpdate({...form, taskList}); onClose(); };

  const addTask = () => {
    if (!newTask.trim()) return;
    setTaskList(p=>[...p,{id:Date.now(),text:newTask,done:false}]);
    setNewTask('');
    setForm(f=>({...f,tasks:{...f.tasks,total:f.tasks.total+1}}));
  };
  const toggleTask = (id) => {
    setTaskList(p=>p.map(t=>t.id===id?{...t,done:!t.done}:t));
    const t = taskList.find(t=>t.id===id);
    if (t) setForm(f=>({...f,tasks:{...f.tasks,done:t.done?f.tasks.done-1:f.tasks.done+1}}));
  };
  const removeTask = (id) => {
    const t = taskList.find(t=>t.id===id);
    setTaskList(p=>p.filter(x=>x.id!==id));
    if (t) setForm(f=>({...f,tasks:{...f.tasks,total:f.tasks.total-1,done:t.done?f.tasks.done-1:f.tasks.done}}));
  };

  return (
    <div className="tm-panel-wrap">
      <div className="tm-overlay" onClick={onClose}/>
      <div className="tm-panel" data-theme={theme}>
        <div className="tm-panel-hd">
          <div className="tm-panel-av">{form.avatar}</div>
          <div className="tm-panel-info">
            <div className="tm-panel-name">{form.name}</div>
            <div className="tm-panel-role">{form.role} · {form.dept}</div>
          </div>
          <button className="tm-icon-btn" onClick={onClose}><CloseIcon/></button>
        </div>

        <div className="tm-panel-acts">
          <a href={`tel:${form.phone}`} className="tm-act-btn"><PhoneIcon/> Call</a>
          <a href={`mailto:${form.email}`} className="tm-act-btn"><MailIcon/> Email</a>
          <button className="tm-act-btn tm-act-edit" onClick={()=>setTab('edit')}><EditIcon/> Edit</button>
        </div>

        <div className="tm-panel-tabs">
          {['overview','tasks','account'].map(t=>(
            <button key={t} className={`tm-ptab${tab===t?' active':''}`} onClick={()=>setTab(t)}>
              {t.charAt(0).toUpperCase()+t.slice(1)}
            </button>
          ))}
        </div>

        <div className="tm-panel-body">
          {tab==='overview' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Performance</div>
              <div className="tm-perf-row">
                <div className="tm-perf-track"><div className="tm-perf-fill" style={{width:form.performance+'%',background:perfColor(form.performance)}}/></div>
                <span className="tm-perf-num" style={{color:perfColor(form.performance)}}>{form.performance}%</span>
              </div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Tasks this month</div>
              <div className="tm-task-row">
                <span className="tm-task-num">{form.tasks.done}/{form.tasks.total}</span>
                <span className="tm-task-pct">{pct}% completion</span>
              </div>
              <div className="tm-perf-track" style={{marginTop:6}}><div className="tm-perf-fill" style={{width:pct+'%',background:'#3B82F6'}}/></div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Details</div>
              <div className="tm-kv">
                <span className="tm-k">Phone</span><span className="tm-v">{form.phone}</span>
                <span className="tm-k">Email</span><span className="tm-v">{form.email}</span>
                <span className="tm-k">Joined</span><span className="tm-v">{new Date(form.joinDate).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'})}</span>
                <span className="tm-k">Leave left</span><span className="tm-v">{form.leaveBalance} days</span>
                <span className="tm-k">Role</span><span className="tm-v" style={{color:'#F5A623',fontWeight:600}}>{form.userRole}</span>
              </div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Today's attendance</div>
              <div className="tm-status-row">
                {['present','leave','absent'].map(s=>(
                  <button key={s} className={`tm-att-btn${form.status===s?' active':''}`}
                    style={form.status===s?{borderColor:s==='present'?'#22C55E':s==='leave'?'#F5A623':'#EF4444'}:{}}
                    onClick={()=>set('status',s)}>
                    {s.charAt(0).toUpperCase()+s.slice(1)}
                  </button>
                ))}
              </div>
            </div>
          </>}

          {tab==='tasks' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Task list</div>
              <div className="tm-task-add-row">
                <input className="tm-task-inp" placeholder="Add a task..." value={newTask} onChange={e=>setNewTask(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addTask()}/>
                <button className="tm-task-add-btn" onClick={addTask}>Add</button>
              </div>
              <div className="tm-task-list">
                {taskList.length===0 && <div className="tm-task-empty">No tasks yet</div>}
                {taskList.map(t=>(
                  <div key={t.id} className={`tm-task-item${t.done?' done':''}`}>
                    <input type="checkbox" checked={t.done} onChange={()=>toggleTask(t.id)} className="tm-task-cb"/>
                    <span className="tm-task-text">{t.text}</span>
                    <button className="tm-task-del" onClick={()=>removeTask(t.id)}>✕</button>
                  </div>
                ))}
              </div>
            </div>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Performance score</div>
              <div className="tm-perf-edit-row">
                <input type="range" min="0" max="100" value={form.performance} onChange={e=>set('performance',parseInt(e.target.value))} className="tm-range"/>
                <span className="tm-perf-num" style={{color:perfColor(form.performance)}}>{form.performance}%</span>
              </div>
            </div>
          </>}

          {tab==='edit' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">Basic info</div>
              {[['name','Full name'],['role','Role'],['phone','Phone'],['email','Email']].map(([k,l])=>(
                <div key={k} className="tm-edit-grp"><label className="tm-lbl">{l}</label><input className="tm-inp" value={form[k]} onChange={e=>set(k,e.target.value)}/></div>
              ))}
              <div className="tm-edit-grp"><label className="tm-lbl">Department</label>
                <select className="tm-inp tm-sel" value={form.dept} onChange={e=>set('dept',e.target.value)}>
                  {DEPTS.filter(d=>d!=='All').map(d=><option key={d}>{d}</option>)}
                </select>
              </div>
              <div className="tm-edit-grp"><label className="tm-lbl">Join date</label><input className="tm-inp" type="date" value={form.joinDate} onChange={e=>set('joinDate',e.target.value)}/></div>
              <div className="tm-edit-grp"><label className="tm-lbl">Leave balance (days)</label><input className="tm-inp" type="number" value={form.leaveBalance} onChange={e=>set('leaveBalance',parseInt(e.target.value)||0)}/></div>
            </div>
          </>}

          {tab==='account' && <>
            <div className="tm-panel-sec">
              <div className="tm-sec-lbl">CRM Access</div>
              <div className="tm-edit-grp"><label className="tm-lbl">Username</label><input className="tm-inp" value={form.username||''} onChange={e=>set('username',e.target.value)}/></div>
              <div className="tm-edit-grp"><label className="tm-lbl">Password</label>
                <div className="tm-pw-wrap">
                  <input className="tm-inp" type={showPw?'text':'password'} value={form.password||''} onChange={e=>set('password',e.target.value)}/>
                  <button className="tm-pw-toggle" onClick={()=>setShowPw(s=>!s)}>{showPw?<EyeOffIcon/>:<EyeIcon/>}</button>
                </div>
              </div>
              <div className="tm-edit-grp"><label className="tm-lbl">Role</label>
                <select className="tm-inp tm-sel" value={form.userRole||'User'} onChange={e=>set('userRole',e.target.value)}>
                  {USER_ROLES.map(r=><option key={r}>{r}</option>)}
                </select>
              </div>
            </div>
          </>}
        </div>

        <div className="tm-panel-ft">
          <button className="tm-btn-danger" onClick={()=>{onDelete(member.id);onClose();}}>Remove</button>
          <button className="tm-btn-pri" style={{flex:1}} onClick={save}>Save</button>
        </div>
      </div>
    </div>
  );
}

function AddModal({ theme, onClose, onAdd }) {
  const [form, setForm] = useState({name:'',role:'',dept:'Sales',phone:'',email:'',joinDate:TODAY,userRole:'User',username:'',password:''});
  const [showPw, setShowPw] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const submit = () => {
    if (!form.name.trim()) return;
    const initials = form.name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
    onAdd({...form,id:Date.now(),avatar:initials,performance:0,status:'present',leaveBalance:15,tasks:{done:0,total:0},taskList:[]});
    onClose();
  };
  return (
    <div className="tm-modal-overlay" onClick={onClose}>
      <div className="tm-modal" data-theme={theme} onClick={e=>e.stopPropagation()}>
        <div className="tm-modal-hd"><span className="tm-modal-title">Add Member</span><button className="tm-icon-btn" onClick={onClose}><CloseIcon/></button></div>
        <div className="tm-modal-body">
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Name *</label><input className="tm-inp" placeholder="Full name" value={form.name} onChange={e=>set('name',e.target.value)}/></div>
            <div className="tm-form-grp"><label className="tm-lbl">Role</label><input className="tm-inp" placeholder="e.g. Sales Executive" value={form.role} onChange={e=>set('role',e.target.value)}/></div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Department</label>
              <select className="tm-inp tm-sel" value={form.dept} onChange={e=>set('dept',e.target.value)}>
                {DEPTS.filter(d=>d!=='All').map(d=><option key={d}>{d}</option>)}
              </select>
            </div>
            <div className="tm-form-grp"><label className="tm-lbl">Join date</label><input className="tm-inp" type="date" value={form.joinDate} onChange={e=>set('joinDate',e.target.value)}/></div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Phone</label><input className="tm-inp" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={e=>set('phone',e.target.value)}/></div>
            <div className="tm-form-grp"><label className="tm-lbl">Email</label><input className="tm-inp" placeholder="email@company.in" value={form.email} onChange={e=>set('email',e.target.value)}/></div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">Username</label><input className="tm-inp" placeholder="username" value={form.username} onChange={e=>set('username',e.target.value)}/></div>
            <div className="tm-form-grp"><label className="tm-lbl">Password</label>
              <div className="tm-pw-wrap">
                <input className="tm-inp" type={showPw?'text':'password'} placeholder="password" value={form.password} onChange={e=>set('password',e.target.value)}/>
                <button className="tm-pw-toggle" onClick={()=>setShowPw(s=>!s)}>{showPw?<EyeOffIcon/>:<EyeIcon/>}</button>
              </div>
            </div>
          </div>
          <div className="tm-form-row">
            <div className="tm-form-grp"><label className="tm-lbl">CRM Role</label>
              <select className="tm-inp tm-sel" value={form.userRole} onChange={e=>set('userRole',e.target.value)}>
                {USER_ROLES.map(r=><option key={r}>{r}</option>)}
              </select>
            </div>
          </div>
        </div>
        <div className="tm-modal-ft">
          <button className="tm-btn-sec" onClick={onClose}>Cancel</button>
          <button className="tm-btn-pri" onClick={submit}>Add Member</button>
        </div>
      </div>
    </div>
  );
}

export default function Team() {
  const { theme } = useTheme();
  const [members, setMembers] = useState(() => {
    try { const s = localStorage.getItem(STORAGE_KEY); return s ? JSON.parse(s) : INIT_MEMBERS; } catch { return INIT_MEMBERS; }
  });
  React.useEffect(() => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(members)); } catch {} }, [members]);

  const [dept, setDept] = useState('All');
  const [selected, setSelected] = useState(null);
  const [showAdd, setShowAdd] = useState(false);

  const filtered = dept==='All' ? members : members.filter(m=>m.dept===dept);
  const present  = members.filter(m=>m.status==='present').length;
  const onLeave  = members.filter(m=>m.status==='leave').length;
  const absent   = members.filter(m=>m.status==='absent').length;
  const avgPerf  = Math.round(members.reduce((s,m)=>s+m.performance,0)/members.length);

  const handleUpdate = updated => setMembers(ms=>ms.map(m=>m.id===updated.id?updated:m));
  const handleAdd    = m => setMembers(ms=>[m,...ms]);
  const handleDelete = id => setMembers(ms=>ms.filter(m=>m.id!==id));

  const TopActions = (
    <div className="tm-top-acts">
      <div className="tm-dept-tabs">
        {DEPTS.map(d=>(
          <button key={d} className={`tm-dept-tab${dept===d?' active':''}`} onClick={()=>setDept(d)}>{d}</button>
        ))}
      </div>
      <button className="tm-add-btn" onClick={()=>setShowAdd(true)}><PlusIcon/> Add Member</button>
    </div>
  );

  return (
    <div className="tm-wrap" data-theme={theme}>
      <Sidebar/>
      <div className="tm-main">
        <Topbar title="Team" subtitle={`${members.length} members · ${present} present today`} actions={TopActions}/>
        <div className="tm-summary">
          {[
            {label:'Present',         val:present,  total:members.length, color:'#22C55E'},
            {label:'On Leave',        val:onLeave,  total:members.length, color:'#F5A623'},
            {label:'Absent',          val:absent,   total:members.length, color:'#EF4444'},
            {label:'Avg Performance', val:avgPerf+'%', color:perfColor(avgPerf), noBar:true},
          ].map(s=>(
            <div key={s.label} className="tm-sum-card">
              <div className="tm-sum-lbl">{s.label}</div>
              <div className="tm-sum-val" style={{color:s.color}}>{s.val}{!s.noBar&&<span className="tm-sum-total">/{s.total}</span>}</div>
              {!s.noBar&&<div className="tm-sum-bar"><div className="tm-sum-fill" style={{width:(s.val/s.total*100)+'%',background:s.color}}/></div>}
            </div>
          ))}
        </div>
        <div className="tm-grid-wrap">
          <div className="tm-grid">
            {filtered.map(m=>(
              <div key={m.id} className="tm-card" onClick={()=>setSelected(m)}>
                <div className="tm-card-top"><div className="tm-card-av">{m.avatar}</div><StatusPill status={m.status}/></div>
                <div className="tm-card-name">{m.name}</div>
                <div className="tm-card-role">{m.role}</div>
                <div className="tm-card-dept">{m.dept}</div>
                <div className="tm-card-perf-row">
                  <div className="tm-card-perf-track"><div className="tm-card-perf-fill" style={{width:m.performance+'%',background:perfColor(m.performance)}}/></div>
                  <span className="tm-card-perf-num" style={{color:perfColor(m.performance)}}>{m.performance}%</span>
                </div>
                <div className="tm-card-tasks">{m.tasks.done}/{m.tasks.total} tasks done</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {selected && <MemberPanel member={selected} theme={theme} onClose={()=>setSelected(null)} onUpdate={handleUpdate} onDelete={handleDelete}/>}
      {showAdd   && <AddModal theme={theme} onClose={()=>setShowAdd(false)} onAdd={handleAdd}/>}
    </div>
  );
}
